// GAVION batch 3: emails. Builds the srcDoc of the sandboxed message viewer.
import { escapeHtml } from "../../domain/email";
import { sanitizeEmailHtml } from "../../email/editor/sanitize";
import type { MessageBodyView } from "../api/types";

// img-src is data: only: remote images are tracking pixels and are not loaded (there is no
// click-to-load); sanitizeEmailHtml strips <img> anyway, this is the second lock.
const CSP = `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data:; style-src 'unsafe-inline'">`;

/** Links open in a new tab, never inside the sandboxed frame (allow-popups only; no scripts). */
function openLinksInNewTab(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("a").forEach((a) => {
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer");
  });
  return doc.body.innerHTML;
}

/** Text is escaped inside <pre>; HTML only ever goes through sanitizeEmailHtml (never raw). */
export function buildSrcDoc(b: MessageBodyView): string {
  const body =
    b.contentType === "text"
      ? `<pre>${escapeHtml(b.content)}</pre>`
      : openLinksInNewTab(sanitizeEmailHtml(b.content));
  return `<!doctype html><html><head>${CSP}<meta charset="utf-8"><style>body{font-family:Arial,sans-serif;font-size:14px;margin:8px}pre{white-space:pre-wrap}</style></head><body>${body}</body></html>`;
}
